import {KeyWordModel, NameResponse} from '@common/models/commonHTTP.models';
import {MoneyAccount} from '@accounting/_common/models/money-account.models';
import {AccountingDocumentAttachment} from '@accounting/_common/models/_accounting.models';
import {ScheduledTask} from '@accounting/_common/models/scheduled-task.models';
import {BankAccount, CompanyContract} from '@accounting/_common/models/company.models';
import {Unit} from '@accounting/_common/models/nomenclature-unit.models';
import {FlowItem} from '@accounting/_common/models/flow-item.models';
import {BalanceAccount} from '@accounting/_common/models/balance-account.models';
import {DahDocumentType, DahShortEntity} from '@common/component-loader/component.types.list';

export interface NomenclatureDocument extends NameResponse {
    date?: string;
    operative?: boolean;
    number?: string;
    type?: NomenclatureDocumentType;
    person?: NameResponse;
    company?: NameResponse;
    companyContract?: CompanyContract;
    companyBankAccount?: BankAccount;
    total?: string;
    paid?: string;
    storage?: NameResponse;
    storageTo?: NameResponse;
    comment?: string;
    refundParent?: DahShortEntity<NomenclatureDocumentType>;
    companyAdvance?: boolean;
    providerNumber?: string;
    additional: NomenclatureDocumentAdditionalType;
    goods?: NomenclatureDocumentData[];
    services?: NomenclatureDocumentData[];
    totalServices?: string;
    totalGoods?: string;
    parentId?: string;
    attachments: AccountingDocumentAttachment[],
    linkedDocuments?: DahShortEntity<DahDocumentType>[],
    companyReconciliationActExists?: boolean,
    unpaidInvoice?: InvoiceShortDocument,
    attachmentsExists?: boolean,
    moneyAccount?: MoneyAccount
}

export interface InvoiceShortDocument extends DahShortEntity<NomenclatureDocumentType> {
    total?: string
}

export interface NomenclatureDocumentData {
    nomenclature?: NameResponse;
    quantity?: string;
    unit?: Unit;
    price?: string;
    amount?: string;
    flowItem?: FlowItem;
    balanceAccount?: BalanceAccount;
}

export interface NomenclatureDocumentAdditionalType {
    balanceAccount?: BalanceAccount,
    companyAdvanceBalanceAccount?: NameResponse,
    parent?: DahShortEntity<DahDocumentType>,
    assemblyPlace?: string,
    documentReason?: string,
    docNumber?: string,
    docDate?: string,
    docType?: string,
    additionalComment?: string,
    scheduleTask?: ScheduledTask,
    header?: NameResponse,
    firstMember?: NameResponse,
    secondMember?: NameResponse,
    thirdMember?: NameResponse,
}

export interface NomenclatureDocumentSearchParams extends KeyWordModel {
    types?: NomenclatureDocumentType[],
    from?: string,
    to?: string,
    company?: NameResponse,
    operative?: boolean,
    goodsOnly?: boolean,
    refundParentType?: NomenclatureDocumentType,
    attachmentsExists?: boolean
}

export interface PrintFormType {
    type: string,
    documentName: string
    fileName?: string
}

export interface SendPaymentInfo {
    receiver: {
        id: string,
        name: string,
        account: string
    },
    comment?: string,
    amount?: string
    type?: 'MF' | 'SSC' | 'PI' | 'EMPLOYEE',
    selected?: boolean
}


export type NomenclatureDocumentType = 'REVENUE_INVOICE' | 'ADVANCE_REPORT' | 'GOODS_POSTING' | 'SALES_INVOICE' | 'GOODS_WRITE_OFF' | 'GOODS_REFUND' | 'GOODS_TRANSFER';
export const NomenclatureDocumentType = {
    REVENUE_INVOICE: 'REVENUE_INVOICE' as NomenclatureDocumentType,
    ADVANCE_REPORT: 'ADVANCE_REPORT' as NomenclatureDocumentType,
    GOODS_POSTING: 'GOODS_POSTING' as NomenclatureDocumentType,
    SALES_INVOICE: 'SALES_INVOICE' as NomenclatureDocumentType,
    GOODS_WRITE_OFF: 'GOODS_WRITE_OFF' as NomenclatureDocumentType,
    GOODS_REFUND: 'GOODS_REFUND' as NomenclatureDocumentType,
    GOODS_TRANSFER: 'GOODS_TRANSFER' as NomenclatureDocumentType,
};
